import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Hub, noBoardContainerId, ObjectType, UserEvent} from 'yougile-model'
import {SubtaskUtil} from '@extensions/subtask-util'
import {getActionNameChangeCustom} from './get-action-name-change-custom'
import {getActionNameChangeDeadline} from './get-action-name-change-deadline'
import {getActionNameChangeExecutor} from './get-action-name-change-executor'
import {getActionNameChangeRepeatTemplate} from './get-action-name-change-repeat-temlate'
import {getActionNameChangeStopwatch} from './get-action-name-change-stopwatch'
import {getActionNameChangeTimer} from './get-action-name-change-timer'
import {getActionNameChangeTimeTracking} from './get-action-name-change-timetracking'
import {getTitle} from './utils'

interface Props {
  event: UserEvent
  objType: ObjectType
  isSticker: boolean
  obj: Hub
}

// eslint-disable-next-line max-lines-per-function
export const getActionName = ({event, objType, isSticker, obj}: Props) => {
  if (!obj) {
    return ''
  }
  switch (event.type) {
    case 'add':
    case 'delete':
    case 'rename':
    case 'restore':
    case 'move': {
      if (isSticker) {
        return `${Lang.findMsg(
          'statAction' + Util.capitalize(event.type) + 'Project'
        )} ${Lang.msg.statActionObjSticker}`
      } else if (objType === 'project') {
        return `${Lang.findMsg(
          'statAction' + Util.capitalize(event.type) + 'Project'
        )} ${Lang.msg.statActionObjProject}`
      } else if (objType === 'task') {
        if (event.type === 'add' || event.type === 'delete') {
          if (
            obj.id === noBoardContainerId ||
            obj.location === noBoardContainerId
          ) {
            const parents = SubtaskUtil.getParentTaskIds(obj.id)
            if (parents?.length) {
              return `${Lang.findMsg(
                'statAction' + Util.capitalize(event.type) + 'Other'
              )} ${Lang.msg.statsTimeline.subtask}`
            }
          }
        }
        return `${Lang.findMsg(
          'statAction' + Util.capitalize(event.type) + 'Other'
        )} ${Lang.findMsg('statActionObj' + Util.capitalize(objType))}`
      } else {
        return `${Lang.findMsg(
          'statAction' + Util.capitalize(event.type) + 'Other'
        )} ${Lang.findMsg('statActionObj' + Util.capitalize(objType))}`
      }
    }
    case 'complete': {
      if (objType === 'project') {
        return Lang.msg.statsTimeline.statActionCompleteProject
      }
      return Lang.msg.statsTimeline.statActionCompleteTask
    }
    case 'uncomplete': {
      if (objType === 'project') {
        return Lang.msg.statsTimeline.statActionUncompleteProject
      }
      return Lang.msg.statsTimeline.statActionUncompleteTask
    }
    case 'message': {
      return Lang.msg.statsTimeline.statActionMessage
    }
    case 'file': {
      if (event.urls.length > 1) {
        return Lang.msg.statsTimeline.statActionAttachedFiles
      } else {
        return Lang.msg.statsTimeline.statActionAttachedFile
      }
    }
    case 'done': {
      return `${Lang.msg.statActionDone}`
    }
    case 'undone': {
      return `${Lang.msg.statActionUnDone}`
    }
    case 'add-user-to-project': {
      if (event.users.length > 1) {
        return `${Lang.msg.statsTimeline.statActionAddUsersToProject(
          getTitle(obj)
        )}:`
      }
      return `${Lang.msg.statsTimeline.statActionAddUserToProject(
        getTitle(obj)
      )}`
    }
    case 'remove-user-from-project': {
      if (event.users.length > 1) {
        return `${Lang.msg.statsTimeline.statActionRemoveUsersFromProject(
          getTitle(obj)
        )}:`
      }
      return `${Lang.msg.statsTimeline.statActionRemoveUserFromProject(
        getTitle(obj)
      )}`
    }
    case 'change-project-roles': {
      return `${Lang.msg.statsTimeline.statActionChangeRolesInProject(
        getTitle(obj)
      )}:`
    }
    case 'executor': {
      return getActionNameChangeExecutor(event)
    }
    case 'deadline': {
      return getActionNameChangeDeadline(event)
    }
    case 'deadlineFailed': {
      return Lang.msg.statsTimeline.statActionDeadlineFailed
    }
    case 'timetracking': {
      return getActionNameChangeTimeTracking(event)
    }
    case 'repeat-template': {
      return getActionNameChangeRepeatTemplate(event)
    }
    case 'timer': {
      return getActionNameChangeTimer(event)
    }
    case 'stopwatch': {
      return getActionNameChangeStopwatch(event)
    }

    case 'string':
    case 'sprint':
    case 'text':
    case 'numeric': {
      return getActionNameChangeCustom(event)
    }

    case 'change-project-permissions': {
      return `${Lang.msg.statsTimeline.statActionChangePermissionsInProject(
        getTitle(obj)
      )}:`
    }
    case 'users': {
      if (event.action === 'add') {
        if (event.users.length > 1) {
          return `${Lang.msg.statsTimeline.statActionAddUsersToCompany}:`
        }
        return `${Lang.msg.statsTimeline.statActionAddUserToCompany}`
      }
      if (event.action === 'delete') {
        if (event.users.length > 1) {
          return `${Lang.msg.statsTimeline.statActionRemoveUsersFromCompany}:`
        }
        return `${Lang.msg.statsTimeline.statActionRemoveUserFromCompany}`
      }
      return '???'
    }
    default:
      return '???'
  }
}
